import DashboardLayout from '@/components/layout/DashboardLayout';
import ActivationPathway from '@/components/ActivationPathway';

const ActivationPathwayPage = () => {
  return (
    <DashboardLayout>
      <div className="max-w-4xl mx-auto">
        <ActivationPathway />
      </div>
    </DashboardLayout>
  );
};

export default ActivationPathwayPage;
